import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
var QUERY = '(prefers-reduced-motion: no-preference)';
var isRenderingOnServer = typeof window === 'undefined';
var getInitialState = function getInitialState() {
  // For our initial server render, we won't know if the user
  // prefers reduced motion, but it doesn't matter. This value
  // will be overwritten on the client, before any animations
  // occur.
  return isRenderingOnServer ? true : !window.matchMedia(QUERY).matches;
};

// Hook from https://www.joshwcomeau.com/react/prefers-reduced-motion/
// Uses the prefers-reduced-motion media query to disable animations in React.
export default function usePrefersReducedMotion() {
  var _useState = useState(getInitialState),
    _useState2 = _slicedToArray(_useState, 2),
    prefersReducedMotion = _useState2[0],
    setPrefersReducedMotion = _useState2[1];
  useEffect(function () {
    var mediaQueryList = window.matchMedia(QUERY);
    var listener = function listener(event) {
      setPrefersReducedMotion(!event.matches);
    };
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', listener);
    } else {
      mediaQueryList.addListener(listener);
    }
    return function () {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener('change', listener);
      } else {
        mediaQueryList.removeListener(listener);
      }
    };
  }, []);
  return prefersReducedMotion;
}